import api from "src/api";
import { isCreditLensFeatureEnabled } from "src/configState/selector";
import { getSpreadId } from "src/spread/model/spread/selector";
import { State } from "src/state";
import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";

const create = actionCreatorFactory("ClientMetadata");

const createAsync = asyncFactory<State>(create);

export const getClientConfig = createAsync<{}, any>(
  "GET_CLINET_CONFIG",
  async (params, dispatch, getState) => {
    const isCreditLens = isCreditLensFeatureEnabled(getState());

    const spreadId = getSpreadId(getState());

    return await api.metadata.getClientConfig(spreadId, isCreditLens);
  }
);

const getClientConfigAction = thunkToAction(getClientConfig.action);
export type GetClientConfigActionType = typeof getClientConfigAction;



// WEBPACK FOOTER //
// ./src/clientMetadata/actions.ts